export default {
    label_task:{
        en:"Eligible List",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Delivery",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Delivery",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details Information",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
    label_replica :{
        en:"Replica",
        bn:"কর্মচারী আইডি"
    },
    label_initial_plants :{
        en:"Initial Plants",
        bn:"কর্মচারী আইডি"
    },
}